
import { SVGProps } from 'react';
const SvgSearch24 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M11 5.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM4 11a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 4 11Z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgSearch24;
